import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  props: {
    controlData: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    associationInfo: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    item() {
      return this.controlData;
    }
  },
  mounted() {
    this.associationChange();
  },
  data() {
    return {};
  },
  created() {
    console.log(this.isEdit, '------isEdit-------');
  },
  methods: {
    init() {},
    blurFun() {
      this.$emit('valueChange', this.item.mark);
    },
    handleOptionClick(item1, index1) {
      this.$set(this.item, 'value', this.formData[this.item.mark]);
      this.item.controlValue.forEach((val, index) => {
        if (index1 !== index) {
          val.showInput = false;
          val.emptyValue = '';
        }
      });
      item1.showInput = item1.isWrite;
      // item1.emptyValue = '';
      this.associationChange();
    },
    associationChange() {
      //如果有关联控件，判断是否显示
      let currentMark = this.item.mark;
      if (this.associationInfo[currentMark]) {
        let associationInfo = this.associationInfo[currentMark];
        associationInfo.forEach(item => {
          let show = false;
          let valueArr = item.value;
          let value = this.formData[currentMark];
          if (valueArr.indexOf(value) > -1) {
            show = true;
          }
          this.$emit('showControl', show, item.targetKey);
        });
        // let show = false;
        // let valueArr = associationInfo.value;
        // let value = this.formData[currentMark];
        // if (valueArr.indexOf(value) > -1) {
        //   show = true;
        // }
        // this.$emit('showControl', show, associationInfo.targetKey);
      }
    }
  }
};